
export default {
  props: {
    /**
     * @values inline, block
     */
    size: {
      type: String,
      default: 'inline',
      validator: value => ['inline', 'block'].includes(value)
    },

    /**
     * @values colors
     */
    color: {
      /** @type {AlturaColors} */
      type: String,
      default: 'primary-500'
    }
  }
};
